import React from 'react';

const SIZES = {
  sm: { outer: 'rounded-lg p-[2.5px]', inner: 'rounded-[7px] px-2.5 py-1', text: 'text-xs' },
  md: { outer: 'rounded-xl p-[3px]', inner: 'rounded-[11px] px-4 py-1.5', text: 'text-xl' },
  lg: { outer: 'rounded-2xl p-1', inner: 'rounded-[15px] px-6 py-2.5 sm:px-8 sm:py-3', text: 'text-3xl sm:text-4xl md:text-5xl' },
};

const MoonLogo = ({ size = 'md', className = '' }) => {
  const s = SIZES[size] || SIZES.md;
  return (
    <span className={`inline-flex ${s.outer} bg-white shadow-[0_2px_10px_rgba(0,0,0,0.45)] ${className}`}>
      <span className={`flex items-center justify-center ${s.inner} bg-black w-full`}>
        <span
          className={`${s.text} font-black text-white leading-none select-none`}
          style={{ fontFamily: "'Arial Black', 'Helvetica Neue', Arial, sans-serif", letterSpacing: '0.03em' }}
        >
          MOON
        </span>
      </span>
    </span>
  );
};

export default MoonLogo;
